import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import { rankFor, rankPill } from './ranks';

const MEDALS = ['🥇', '🥈', '🥉'];
let state = { loaded: false, rows: [] };

function load() {
  if (state.loading || state.loaded) return;
  state.loading = true;
  app
    .request({ method: 'GET', url: app.forum.attribute('apiUrl') + '/jaecoo/top-contributors' })
    .then((res) => (state.rows = res.data || []))
    .catch(() => {})
    .then(() => {
      state.loading = false;
      state.loaded = true;
      m.redraw();
    });
}

export default function addTopContributors() {
  extend(IndexPage.prototype, 'oninit', load);

  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    if (!state.loaded || !state.rows.length) return;
    items.add(
      'jaecoo-top-contributors',
      <div className="TopContributors">
        <h4 className="TopContributors-title">🏆 Top Contributors <small>this week</small></h4>
        <ol className="TopContributors-list">
          {state.rows.map((r, i) => (
            <li className={`TopContributors-item TopContributors-item--${i + 1}`}>
              <a href={app.route('user', { username: r.username })} onclick={(e) => { e.preventDefault(); m.route.set(app.route('user', { username: r.username })); }}>
                <span className="TopContributors-medal">{MEDALS[i]}</span>
                {r.avatar ? <img className="Avatar TopContributors-avatar" src={r.avatar} alt="" /> : <span className="Avatar TopContributors-avatar TopContributors-avatar--blank">{r.name.charAt(0).toUpperCase()}</span>}
                <span className="TopContributors-meta">
                  <span className="TopContributors-name">{r.name}</span>
                  <span className="TopContributors-sub">
                    {rankPill(rankFor(r.total, r.groups))}
                    <span className="TopContributors-count">{r.posts} {r.posts === 1 ? 'post' : 'posts'}</span>
                  </span>
                </span>
              </a>
            </li>
          ))}
        </ol>
        <p className="TopContributors-foot">Rank up by posting: Regular 5 · Enthusiast 10 · Veteran 25 · Legend 50</p>
      </div>,
      -50
    );
  });
}
